var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component } from 'vue-property-decorator';
import { UrlHelper } from '../../helper/UrlWrapper';
import GlobalVue from '../../globalVue';
import WarningRuleService from '../../api/WarningRuleService';
import { Loading } from 'element-ui';
import Add from './Add.vue';
import Header from './components/Header.vue';
import ImportData from '../../components/dataActions/ImportData.vue';
import CommonService from "../../api/CommonService";
var editSelectRowId = '';
var initFormData = {
    max_stock: '',
    safe_stock: '',
    shelflife_stock_warning_type: '',
    unsalable_day: '',
};
var WarningRuleList = (function (_super) {
    __extends(WarningRuleList, _super);
    function WarningRuleList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.selectRows = [];
        _this.tableHeight = 300;
        _this.warningRuleVisbile = false;
        _this.warningTypeOptions = [];
        _this.formData = __assign({}, initFormData);
        return _this;
    }
    WarningRuleList.prototype.created = function () {
        this.service = WarningRuleService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    WarningRuleList.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 240;
        }, 300);
        this.getList();
    };
    WarningRuleList.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.importAudit();
                break;
            case 2:
                this.exportData();
                break;
            case 3:
                this.changeStatus(0);
                break;
            case 4:
                this.changeStatus(1);
                break;
        }
    };
    WarningRuleList.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    WarningRuleList.prototype.add = function () {
        this.addTab({
            component: Add,
            title: '添加预警规则',
            showExist: true,
            name: 'warningrule_add',
            cprops: {},
        });
    };
    WarningRuleList.prototype.ruleDialogHide = function () {
        var _this = this;
        this.warningRuleVisbile = false;
        this.$nextTick(function () {
            _this.formData = __assign({}, initFormData);
        });
    };
    WarningRuleList.prototype.changeWarningRule = function () {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            if (!res)
                return _this.$message.error('请填写所有必填字段，并且按字段格式要求填写');
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = __assign({ rule_ids: editSelectRowId }, _this.formData);
            _this.service
                .updateWarningRule(params)
                .then(function (res) {
                loadingInstance.close();
                _this.$message.success(res.data.msg);
                _this.ruleDialogHide();
                _this.getList();
            })
                .catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message);
            });
        });
    };
    WarningRuleList.prototype.edit = function (row) {
        if (!row && !this.checkSelectIds())
            return;
        if (row) {
            editSelectRowId = row.stock_warning_rule_id;
            this.formData = {
                max_stock: row.max_stock ? parseFloat(row.max_stock) : '',
                safe_stock: row.safe_stock ? parseFloat(row.safe_stock) : '',
                shelflife_stock_warning_type: row.shelflife_stock_warning_type,
                unsalable_day: row.unsalable_day,
            };
        }
        else {
            editSelectRowId = this.getSelectIds();
        }
        this.warningRuleVisbile = true;
        if (!this.warningTypeOptions.length)
            this.getWarningTypeOptions();
    };
    WarningRuleList.prototype.getWarningTypeOptions = function () {
        var _this = this;
        this.service.getWarningTypeOptions().then(function (res) {
            if (res.data.success) {
                _this.warningTypeOptions = res.data.data;
            }
        });
    };
    WarningRuleList.prototype.importAudit = function () {
        this.$refs.ImportData.showImportModal();
    };
    WarningRuleList.prototype.exportData = function () {
        var _this = this;
        var rule_ids = this.getSelectIds();
        var url = 'supplierclientapi/stock_warning_rule/export?rule_ids=' + rule_ids;
        url = UrlHelper.addParam(url, 'token', this.user.token);
        for (var key in this.filter) {
            this.filter[key] = (this.filter[key] === undefined || this.filter[key] === null) ? '' : this.filter[key];
            url = UrlHelper.addParam(url, key, this.filter[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        window._czc.push(['_trackEvent', '预警规则', '预警规则导出']);
    };
    WarningRuleList.prototype.changeStatus = function (status, row) {
        var _this = this;
        if (!row && !this.checkSelectIds())
            return;
        var confirmParams = {
            content: status ? '启用后对该货品进行预警，确定启用吗？' : '停用后会停止对该货品进行预警功能，确定停用吗？',
            title: status ? '启用预警' : '停用预警',
        };
        this.$confirm(confirmParams.content, confirmParams.title).then(function (res) {
            var loadingInstance = Loading.service({ fullscreen: true });
            var rule_ids = _this.getSelectIds();
            if (row)
                rule_ids = row.stock_warning_rule_id;
            _this.service
                .updateWarningRuleStatus({
                rule_ids: rule_ids,
                status: status,
            })
                .then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success(res.data.msg);
                }
                _this.getList();
            })
                .catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.message);
            });
        });
    };
    WarningRuleList.prototype.getSelectIds = function () {
        var ruleIds = this.selectRows.map(function (item) { return item.stock_warning_rule_id; });
        return ruleIds.join(',');
    };
    WarningRuleList.prototype.checkSelectIds = function () {
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择单据！');
            return false;
        }
        else {
            return true;
        }
    };
    WarningRuleList.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    WarningRuleList.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        this.filter = filter;
        this.getList();
    };
    WarningRuleList.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getList(Object.assign({}, this.filter, pager))
            .then(function (res) {
            loadingInstance.close();
            var DATA = res.data;
            _this.listData = DATA.data;
            _this.total = DATA.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    WarningRuleList.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    WarningRuleList = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
            components: {
                'list-header': Header,
                'import-data': ImportData,
            },
        })
    ], WarningRuleList);
    return WarningRuleList;
}(Vue));
export default WarningRuleList;
